import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/Partners/helpers'
import partnersRepository from '@/repository/generatedRepository/partnersRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'

const state = {
  list: [],
  filters: StorageService.get(storageKeys.PARTNERS_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
  unapprovedPartners: 0,
  partnerGroupPartnerList: [],
  partnerGroupPartnerTableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  unapprovedPartners: state => state.unapprovedPartners,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
  partnerGroupPartnerList: state => state.partnerGroupPartnerList,
  partnerGroupPartnerTableOptions: state => state.partnerGroupPartnerTableOptions,

}

const actions = {
  async loadData(context, payload) {
    const {signal, ...filters} = payload
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.PARTNERS_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
      signal,
      with_categories: 1,
    })

    const { data } = await partnersRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async loadPartnerGroupPartnerData(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    const { data } = await partnersRepository.list(preparedFilters)

    context.commit('setPartnerGroupPartnerList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async searchPartners(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })

    const { data } = await partnersRepository.list(preparedFilters)
    context.commit('setUnapprovedPartners', { data })
    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await partnersRepository.get(id)
    return data
  },
  createItem(context, payload) {
    return partnersRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return partnersRepository.put(id, data)
  },
  deleteItem(context, payload) {
    return partnersRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.PARTNERS_FILTERS)
  },
  resetSearchFilter({commit}){
    commit('clearSearch')
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.PARTNERS_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.unapprovedPartners = data.count_data?.unapproved[0]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setUnapprovedPartners(state, { data }) {
    state.unapprovedPartners = data.count_data.unapproved[0]
  },
  setPartnerGroupPartnerList(state, { data, filters }) {
    state.partnerGroupPartnerList = [...data.items]
    state.partnerGroupPartnerTableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
  clearSearch(state) {
    state.tableOptions.search = ''
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
